import React, { useContext, useState } from 'react'
import Modal from '../../../../components/Modal'
import { AuthContext } from '../../../../context/AuthContext'
import { useHttp } from '../../../../hooks/http.hook'
import validator from '../../../../hooks/validator.hook'
import { observer } from 'mobx-react'
import ModalForm from '../../../../components/Modals/ModalForm/ModalForm'
import PatientPageStore from '../Store/PatientPageStore'
import FormInput from '../../../../components/Inputs/FormInput/FormInput'
import FormAttention from '../../../../components/FormAttention'
import AttentionGenerator from '../../../../components/Form/AttentionGenerator'
import {io} from "socket.io-client";



const ChangePasswordModal = observer(() => {
  const { token, login, userId } = useContext(AuthContext)
  const { request } = useHttp()
  const { validatePassword } = validator()
  const [status, setStatus] = useState(0)

  const [formData, setFormData] = useState({
    password: '',
    newPassword: ''
  })

  // const validPassword = validatePassword(formData.password)

  const baseURL = process.env.REACT_APP_BASE_URL
  const changePasswordRequest = async (newPassword) => {
    const url = `${baseURL}/api/v2/patients/${userId}/password`
    const { data, status } = await request(url, 'PUT', newPassword, { Authorization: `Bearer ${token}` })
    setStatus(status)
    if (status === 200) {
      login(data.data)
    }
  }
  const submitHandler = e => {
    e.preventDefault()
    changePasswordRequest(formData)
  }
  const inputHandler = event => {
    setFormData({ ...formData, [event.target.name]: event.target.value })
  }
  return (
    <Modal>
      <ModalForm
        ready={status === 200}
        readyText={'Пароль изменен!'}
        readyBtnText={'Продолжить'}
        onSubmit={submitHandler}
        onSubmitTitle={'Изменить пароль'}
        title={'Смена пароля'}
        closeHandler={() => PatientPageStore.closePasswordChangeModal()}
        submitDisabled={!validatePassword(formData.newPassword)}
      >

        <AttentionGenerator errors={{
          error: {
            message: status === 401 ? 'Неправильно введен старый пароль' : ''
          }
        }}
        />
        <FormInput name={'password'}
                   type={'password'}
                   onChange={e => inputHandler(e)}
                   minLength={6}
                   hideIcon
                   maxLength={15}
                   required={true}
                   showAttention={status === 401}
                   attentionText={'Неверный пароль'}
        >
          Старый пароль
        </FormInput>

        <FormInput name={'newPassword'}
                   type={'password'}
                   onChange={e => inputHandler(e)}
                   minLength={6}
                   maxLength={15}
                   required={true}
                   hideIcon
        >
          Новый пароль
        </FormInput>

      </ModalForm>
    </Modal>
  )
})

export default ChangePasswordModal
